// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chat-check';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M17.437 12.938a4.5 4.5 0 1 1-4.5-4.5' />
    <path d='m17.437 9.563-4.103 4.101a.562.562 0 0 1-.795 0l-1.289-1.289m-5.083 2.55-3.354 2.513v-3.375H1.687a1.125 1.125 0 0 1-1.125-1.126V1.688A1.125 1.125 0 0 1 1.688.563h14.626a1.125 1.125 0 0 1 1.125 1.125v5.625' />
  </g>
);

export const viewBox = '0 0 18 18';
